import styled from 'styled-components';
import { Fonts, Palette } from '../utils';

export const WizardShell = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  box-sizing: border-box;
`;

export const WizardHeaderBlock = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

export const StepRow = styled.div`
  align-self: stretch;
  width: 100%;
  min-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

export const StepMeta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const StepLabel = styled.div`
  color: ${Palette.OCEANIC};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const StepNameLabel = styled.div`
  color: ${Palette.CONTENT_TERTIARY};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const StepMetaDivider = styled.span`
  flex-shrink: 0;
  width: 1px;
  height: 16px;
  align-self: center;
  background-color: ${Palette.CONTENT_TERTIARY};
`;

export const ProgressDots = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProgressSegment = styled.div`
  width: 27px;
  height: 6px;
  border-radius: 3px;
  background: ${({ $active }) => ($active ? Palette.OCEANIC : Palette.BRAND_DARK_BLUE)};
`;

export const WizardTitle = styled.div`
  align-self: stretch;
  color: ${Palette.BLACK};
  font-size: 20px;
  font-family: ${Fonts.RED_HAT_FONT}, sans-serif;
  font-weight: 700;
  line-height: 36px;
`;

export const WizardStepDescription = styled.div`
  align-self: stretch;
  color: ${Palette.CONTENT_TERTIARY};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

export const FieldBlock = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const FieldInner = styled.div`
  width: 100%;
  max-width: 412px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const FieldInnerFull = styled(FieldInner)`
  max-width: none;
`;

export const FieldLabel = styled.div`
  color: ${Palette.BLACK};
  font-size: 12px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

export const BookingWizardStepPane = styled.div`
  width: 100%;
  min-height: 492px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
`;

export const ReviewDivider = styled.div`
  align-self: stretch;
  width: 100%;
  height: 0;
  border-top: 1px solid ${Palette.BORDER_OUTLINE};
`;

export const ReviewSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
`;

export const ReviewSectionTitle = styled.div`
  color: ${Palette.HAZY_BLUE};
  font-size: 12px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const ReviewDoubleRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
`;

export const ReviewItem = styled.div`
  flex: 1 1 calc(50% - 12px);
  min-width: 160px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;

export const ReviewItemLabel = styled.div`
  align-self: stretch;
  color: ${Palette.OCEANIC};
  font-size: 12px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

export const ReviewItemValue = styled.div`
  align-self: stretch;
  color: ${Palette.BLACK};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

export const ReviewItemValueMuted = styled(ReviewItemValue)`
  color: ${Palette.CONTENT_DISABLED};
`;

export const WizardFooterButtonPrimary = styled.button`
  min-width: 142px;
  padding: 4px 16px;
  box-sizing: border-box;
  background: ${Palette.HAZY_BLUE};
  border: none;
  border-radius: 999px;
  color: ${Palette.WHITE};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.95;
  }

  &:not(:disabled):focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
  }
`;

export const WizardFooterButtonSecondary = styled.button`
  min-width: 142px;
  padding: 4px 16px;
  box-sizing: border-box;
  background: ${Palette.GHOST_WHITE};
  border: 1px solid ${Palette.HAZY_BLUE};
  border-radius: 999px;
  color: ${Palette.BLACK};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.92;
  }

  &:not(:disabled):focus-visible {
    outline: 2px solid ${Palette.OCEANIC};
    outline-offset: 2px;
  }
`;
